import React, { useEffect, useState } from 'react';
import { X, Filter, RefreshCw } from 'lucide-react';

export default function ContaPagarDetalhe({ data, onClose }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Estados dos Filtros de Requisição (Backend)
  const [filtroMes, setFiltroMes] = useState(new Date().getMonth() + 1);
  const [filtroAno, setFiltroAno] = useState(new Date().getFullYear());
  const [filtroEmpresa, setFiltroEmpresa] = useState('');

  // Estados dos Filtros Locais (Grid)
  const [selectedEmpresa, setSelectedEmpresa] = useState('');
  const [selectedFornecedor, setSelectedFornecedor] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedValor, setSelectedValor] = useState('');
  const [selectedForma, setSelectedForma] = useState('');
  const [selectedNomeConta, setSelectedNomeConta] = useState('');
  const [selectedSequencial, setSelectedSequencial] = useState('');
  const [selectedDocumento, setSelectedDocumento] = useState('');

  const base_url = 'https://onboard.fck.ind.br';

  const carregarDetalhes = () => {
    setLoading(true);
    const token = localStorage.getItem('@user_token');
    if (!token) { setLoading(false); return; }

    const params = new URLSearchParams({
      mes: filtroMes,
      ano: filtroAno,
    });
    if (filtroEmpresa) params.append('empresa', filtroEmpresa);

    fetch(`${base_url}/api/dashboard/financeiro/ContaPagarDetalhe?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(json => {
        setItems(Array.isArray(json) ? json : [json]);
      })
      .catch(err => console.error("Erro ao buscar detalhes:", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    carregarDetalhes();
  }, [filtroMes, filtroAno, filtroEmpresa]);

  const formatBRL = (val) => 
    `R$ ${Number(val || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;

  const formatDataBR = (dataString) => {
    if (!dataString) return '-';
    try {
      const dataObj = new Date(dataString);
      if (isNaN(dataObj.getTime())) return '-';
      
      const dia = String(dataObj.getUTCDate()).padStart(2, '0');
      const mes = String(dataObj.getUTCMonth() + 1).padStart(2, '0');
      const ano = dataObj.getUTCFullYear();
      
      return `${dia}/${mes}/${ano}`;
    } catch {
      return '-';
    }
  };

  const getValue = (obj, key) => {
    if (!obj) return '';
    const lowerKey = key.charAt(0).toLowerCase() + key.slice(1);
    return obj[key] !== undefined ? obj[key] : (obj[lowerKey] !== undefined ? obj[lowerKey] : '');
  };

  const getUniqueValues = (key) => {
    return [...new Set(items.map(item => getValue(item, key)))]
      .filter(val => val !== null && val !== undefined && val !== '')
      .sort();
  };

  const itemsFiltrados = items.filter(item => {
    return (
      (selectedEmpresa === '' || String(getValue(item, 'Empresa')) === selectedEmpresa) &&
      (selectedFornecedor === '' || String(getValue(item, 'Fornecedor')) === selectedFornecedor) &&
      (selectedStatus === '' || String(getValue(item, 'Status')) === selectedStatus) &&
      (selectedValor === '' || String(getValue(item, 'Valor')) === selectedValor) &&
      (selectedForma === '' || String(getValue(item, 'FormaCobranca')) === selectedForma) &&
      (selectedNomeConta === '' || String(getValue(item, 'NomeConta')) === selectedNomeConta) &&
      (selectedSequencial === '' || String(getValue(item, 'Sequencial')) === selectedSequencial) &&
      (selectedDocumento === '' || String(getValue(item, 'Documento')) === selectedDocumento)
    );
  });

  // Cálculo dinâmico do somatório total da coluna ValorAprop baseado nos itens filtrados
  const totalValorAprop = itemsFiltrados.reduce((acc, item) => {
    const val = Number(getValue(item, 'ValorAprop') || 0);
    return acc + val;
  }, 0);
  const totalValor = itemsFiltrados.reduce((acc, item) => {
    const val = Number(getValue(item, 'Valor') || 0);
    return acc + val;
  }, 0);

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="bg-[#0d1117] border border-gray-800 w-full max-w-7xl h-[90vh] rounded-lg shadow-2xl flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* Cabeçalho */}
        <div className="flex justify-between items-center p-4 border-b border-gray-800 bg-[#161b22]">
          <div className="flex items-center gap-2 text-yellow-500 font-bold tracking-widest text-xs uppercase">
            <span>Detalhamento Avançado de Contas a Pagar</span>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors">
            <X size={20} />
          </button>
        </div>

        {/* Barra de Filtros API */}
        <div className="p-4 bg-[#161b22]/50 border-b border-gray-800 grid grid-cols-1 sm:grid-cols-4 gap-3 items-end">
          <div>
            <label className="text-gray-500 text-[10px] uppercase font-bold block mb-1">Mês Ref (API)</label>
            <input type="number" min="1" max="12" value={filtroMes} onChange={(e) => setFiltroMes(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded px-2 py-1 text-sm text-white font-mono" />
          </div>
          <div>
            <label className="text-gray-500 text-[10px] uppercase font-bold block mb-1">Ano Ref (API)</label>
            <input type="number" value={filtroAno} onChange={(e) => setFiltroAno(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded px-2 py-1 text-sm text-white font-mono" />
          </div>
          <div>
            <label className="text-gray-500 text-[10px] uppercase font-bold block mb-1">Empresa (API)</label>
            <select value={filtroEmpresa} onChange={(e) => setFiltroEmpresa(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded px-2 py-1 text-sm text-white">
              <option value="">Todas</option>
              <option value="1">FCK-SJL</option>
              <option value="2">FCK-CTG</option>
              <option value="3">FCK-BHZ</option>
            </select>
          </div>
          <button onClick={carregarDetalhes} className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-700 text-white text-[10px] font-black h-8 px-4 rounded transition-all uppercase tracking-widest shadow-lg">
            <RefreshCw size={12} /> Atualizar
          </button>
        </div>

        {/* Grid de Filtros Locais */}
        <div className="p-4 bg-[#161b22] border-b border-gray-800 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-2 text-xs">
          <div>
            <select value={selectedEmpresa} onChange={(e) => setSelectedEmpresa(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded p-1 text-gray-300">
              <option value="">Empresa</option>
              {getUniqueValues('Empresa').map(val => <option key={val} value={val}>{val}</option>)}
            </select>
          </div>
          <div>
            <select value={selectedSequencial} onChange={(e) => setSelectedSequencial(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded p-1 text-gray-300">
              <option value="">Sequencial</option>
              {getUniqueValues('Sequencial').map(val => <option key={val} value={val}>{val}</option>)}
            </select>
          </div>
          <div>
            <select value={selectedDocumento} onChange={(e) => setSelectedDocumento(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded p-1 text-gray-300">
              <option value="">Documento</option>
              {getUniqueValues('Documento').map(val => <option key={val} value={val}>{val}</option>)}
            </select>
          </div>
          <div>
            <select value={selectedFornecedor} onChange={(e) => setSelectedFornecedor(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded p-1 text-gray-300">
              <option value="">Fornecedor</option>
              {getUniqueValues('Fornecedor').map(val => <option key={val} value={val}>{val}</option>)}
            </select>
          </div>
          <div>
            <select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded p-1 text-gray-300">
              <option value="">Status</option>
              {getUniqueValues('Status').map(val => <option key={val} value={val}>{val}</option>)}
            </select>
          </div>
          {/*<div>
            <select value={selectedValor} onChange={(e) => setSelectedValor(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded p-1 text-gray-300">
              <option value="">Valor</option>
              {getUniqueValues('Valor').map(val => <option key={val} value={val}>{formatBRL(val)}</option>)}
            </select>
          </div>*/}
          <div>
            <select value={selectedForma} onChange={(e) => setSelectedForma(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded p-1 text-gray-300">
              <option value="">Forma Cob.</option>
              {getUniqueValues('FormaCobranca').map(val => <option key={val} value={val}>{val}</option>)}
            </select>
          </div>
          <div>
            <select value={selectedNomeConta} onChange={(e) => setSelectedNomeConta(e.target.value)} className="w-full bg-[#0d1117] border border-gray-800 rounded p-1 text-gray-300">
              <option value="">Nome Conta</option>
              {getUniqueValues('NomeConta').map(val => <option key={val} value={val}>{val}</option>)}
            </select>
          </div>
        </div>

        {/* Tabela de Dados */}
        <div className="flex-1 overflow-auto p-4 bg-[#0d1117]">
          {loading ? (
            <div className="w-full flex items-center justify-center h-48 text-yellow-500 font-bold animate-pulse uppercase tracking-widest text-xs">
              Carregando registros detalhados...
            </div>
          ) : itemsFiltrados.length === 0 ? (
            <div className="w-full flex items-center justify-center h-48 text-gray-600 font-bold uppercase tracking-widest text-xs">
              Nenhum registro encontrado para os filtros atuais.
            </div>
          ) : (
            <div className="overflow-x-auto border border-gray-800 rounded">
              <table className="min-w-full divide-y divide-gray-800 text-left text-xs">
                <thead className="bg-[#161b22] text-gray-400 uppercase font-black tracking-wider sticky top-0 z-10">
                  <tr>
                    <th className="px-3 py-3">Empresa</th>
                    <th className="px-3 py-3 text-center">Seq.</th>
                    <th className="px-3 py-3">Documento</th>
                    <th className="px-3 py-3">Fornecedor</th>
                    <th className="px-3 py-3 text-center">Data Venc.</th>
                    <th className="px-3 py-3 text-center">Quitação</th>
                    <th className="px-3 py-3 text-center">Status</th>
                   {/*<th className="px-3 py-3 text-right">Valor</th>*/}
                    <th className="px-3 py-3">Forma Cobr.</th>
                    <th className="px-3 py-3">Nome Conta</th>
                    <th className="px-3 py-3 text-right">Valor</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-800 bg-[#0d1117] text-gray-300 font-medium">
                  {itemsFiltrados.map((item, index) => {
                    const statusVal = getValue(item, 'Status');
                    const dataVenc = getValue(item, 'DataVencimento');
                    const dataQuit = getValue(item, 'Quitacao');

                    return (
                      <tr key={index} className="hover:bg-[#161b22]/40 transition-colors">
                        <td className="px-3 py-3 whitespace-nowrap font-bold text-white">{getValue(item, 'Empresa')}</td>
                        <td className="px-3 py-3 text-center font-mono text-gray-400">{getValue(item, 'Sequencial')}</td>
                        <td className="px-3 py-3 font-mono text-gray-300 whitespace-nowrap">{getValue(item, 'Documento') || '-'}</td>
                        <td className="px-3 py-3 truncate max-w-[180px]" title={getValue(item, 'Fornecedor')}>{getValue(item, 'Fornecedor')}</td>
                        <td className="px-3 py-3 text-center font-mono whitespace-nowrap">{(dataVenc)}</td>
                        <td className="px-3 py-3 text-center font-mono whitespace-nowrap">{formatDataBR(dataQuit)}</td>
                        <td className="px-3 py-3 text-center">
                          <span className={`px-2 py-0.5 rounded-full text-[10px] font-black uppercase ${statusVal === 'Quitado' ? 'bg-green-950 text-green-400 border border-green-800' : 'bg-yellow-950 text-yellow-400 border border-yellow-800'}`}>
                            {statusVal || 'Pendente'}
                          </span>
                        </td>
                       {/* <td className="px-3 py-3 text-right font-mono font-bold text-white">{formatBRL(getValue(item, 'Valor'))}</td>*/}
                        <td className="px-3 py-3 whitespace-nowrap text-gray-400">{getValue(item, 'FormaCobranca') || '-'}</td>
                        <td className="px-3 py-3 truncate max-w-[150px]" title={getValue(item, 'NomeConta')}>{getValue(item, 'NomeConta') || '-'}</td>
                        <td className="px-3 py-3 text-right font-mono text-emerald-400">{formatBRL(getValue(item, 'ValorAprop'))}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Rodapé Alinhado com a Coluna do Grid */}
        <div className="p-4 bg-[#161b22] border-t border-gray-800 grid grid-cols-3 items-center text-[10px] uppercase font-bold tracking-wider text-gray-500">
          {/* Esquerda: Contador de registros */}
          <div className="text-left">
            Registros exibidos: <span className="text-white font-mono">{itemsFiltrados.length}</span> de <span className="text-gray-400 font-mono">{items.length}</span>
          </div>

          {/* Centro: Botão de ação */}
          <div className="text-center">
            <button onClick={onClose} className="bg-gray-800 hover:bg-gray-700 text-white text-[10px] font-black py-1.5 px-6 rounded transition-all shadow-lg uppercase tracking-widest">
              Fechar Janela
            </button>
          </div>

          {/* Direita: Total de Apropriação perfeitamente alinhado com o fim da tabela */}
          <div className="text-right">
            Total: <span className="text-emerald-400 font-mono text-xs font-black ml-1">{formatBRL(totalValorAprop)}</span>
          </div>
          {/*<div className="text-right">
            Total.: <span className="text-emerald-400 font-mono text-xs font-black ml-1">{formatBRL(totalValor)}</span>
          </div>*/}
        </div>

      </div>
    </div>
  );
}